import React from "react";
import { TextField, SelectField } from "components/support";
import { DialogContent } from "material-ui-next/Dialog";

const defaultOption = {
  value: "",
  label: "Selecionar",
  disabled: true
};

const handleOptions = options =>
  options.map(option => ({
    value: option.id,
    label: `${option.name}`
  }));

const buildOptions = options => [defaultOption, ...handleOptions(options)];

class Content extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      organizationsOptions: [defaultOption],
      stocksOptions: [defaultOption],
      saleChannelsOptions: [defaultOption],
      token: "",
      organizationId: "",
      stockId: "",
      saleChannelId: ""
    };
  }

  handleTokenChange(e) {
    const { changeForm, presenter } = this.props;

    this.setState({
      token: e.target.value,
      organizationId: "",
      stockId: "",
      saleChannelId: ""
    });

    changeForm({
      token: e.target.value,
      organization_id: "",
      stock_id: "",
      sale_channel_id: ""
    });

    presenter.fetchOrganizations(e.target.value);
  }

  handleOrganizationChange(e) {
    const { changeForm, presenter, form } = this.props;

    this.setState({
      organizationId: e.target.value,
      stockId: "",
      saleChannelId: ""
    });

    changeForm({
      organization_id: e.target.value,
      organization_name: e.target.selectedOptions[0].innerText,
      stock_id: "",
      sale_channel_id: ""
    });

    presenter.fetchStocks(form.token, e.target.value);
  }

  handleStockChange(e) {
    const { changeForm, presenter, form } = this.props;

    this.setState({
      stockId: e.target.value,
      saleChannelId: ""
    });

    changeForm({
      stock_id: e.target.value,
      stock_name: e.target.selectedOptions[0].innerText,
      sale_channel_id: ""
    });

    presenter.fetchSaleChannels(
      form.token,
      form.organization_id,
      e.target.value
    );
  }

  handleSaleChannelsChange(e) {
    const { changeForm } = this.props;

    this.setState({
      saleChannelId: e.target.value
    });

    changeForm({
      sale_channel_id: e.target.value,
      sale_channel_name: e.target.selectedOptions[0].innerText
    });
  }

  componentDidMount() {
    const { presenter, form, editing } = this.props;

    if (editing) {
      presenter.fetchOrganizations(form.token);
      presenter.fetchStocks(form.token, form.organization_id);
      presenter.fetchSaleChannels(
        form.token,
        form.organization_id,
        form.stock_id
      );

      this.setState({
        token: form.token,
        organizationId: form.organization_id,
        stockId: form.stock_id,
        saleChannelId: form.sale_channel_id
      });
    }
  }

  componentDidUpdate(prevProps) {
    if (prevProps !== this.props) {
      this.setState({
        organizationsOptions: buildOptions(this.props.organizations),
        stocksOptions: buildOptions(this.props.stocks),
        saleChannelsOptions: buildOptions(this.props.sale_channels)
      });
    }
  }

  render() {
    const {
      form,
      error,
      presenter,
      organizations,
      stocks,
      sale_channels
    } = this.props;

    return (
      <DialogContent>
        <TextField
          fullWidth
          label="Token"
          value={this.state.token}
          errorText={error["token"]}
          onChange={e => this.handleTokenChange(e)}
        />

        <SelectField
          floatingLabelText="Organização"
          value={this.state.organizationId}
          fullWidth
          options={this.state.organizationsOptions}
          errorText={error["organization_id"]}
          disabled={!form.token || organizations.length === 0}
          onChange={e => this.handleOrganizationChange(e)}
          onFocus={() => presenter.fetchOrganizations(form.token)}
        />

        <SelectField
          floatingLabelText="Estoques"
          value={this.state.stockId}
          fullWidth
          options={this.state.stocksOptions}
          errorText={error["stock_id"]}
          disabled={!form.organization_id || stocks.length === 0}
          onChange={e => this.handleStockChange(e)}
          onFocus={() =>
            presenter.fetchStocks(form.token, form.organization_id)
          }
        />

        <SelectField
          floatingLabelText="Canal de Venda"
          value={this.state.saleChannelId}
          fullWidth
          options={this.state.saleChannelsOptions}
          errorText={error["sale_channel_id"]}
          disabled={!form.stock_id || sale_channels.length === 0}
          onChange={e => this.handleSaleChannelsChange(e)}
          onFocus={() =>
            presenter.fetchSaleChannels(
              form.token,
              form.organization_id,
              form.stock_id
            )
          }
        />
      </DialogContent>
    );
  }
}

export default Content;



// WEBPACK FOOTER //
// ./src/components/app/registration/company/form/integrations/oms/dialog/DialogContent/DialogContent.jsx